<Grid>

    <GridItem span="8-of-12">

        {#if aside}
        <svelte:component this={aside.component} {...aside.props} />
        {/if}

    </GridItem>

    <GridItem span="4-of-12" class="spacing spacing--padding-large-portrait">
        
        {#if article}
        <svelte:component this={article.component} {...article.props} />
        {/if}

        {#if posts.length}

        <div class="post__options spacing spacing--padding-large">

            <Link to={id} baseUrl={baseUrl} button>Weiterlesen</Link>

        </div>

        {/if}

    </GridItem>

</Grid>

<style>

    .post__options {
        position: absolute;
        left: 0;
        bottom: 0;
    }

</style>

<script>
    // components
    import Link from 'components/Link.html'
    import Grid from 'components/Grid.html'
    import GridItem from 'components/GridItem.html'

    // views
    import Software from 'views/compounds/Software.html'

    export default {
        components: {
            Link,
            Grid,
            GridItem
        },
        data() {
            return {
                id: '',
                article: null,
                aside: null,
                posts: [],
                baseUrl: '/'
            }
        }
    }
</script>